import { FC } from "react"
import { FcAddRow, FcCustomerSupport, FcInTransit } from "react-icons/fc"

export interface IHowCSWorks {
  blok: {
    title?: string
    items: { icon?: string; text: string }[]
  }
}
const icons = ["📦", "💬", "🚚"]

const HowCSWorks: FC<IHowCSWorks> = ({ blok }) => (
  <div className="max-w-[1240px] mx-auto px-6 my-12 md:pt-10 md:pb-0">
    {blok.title && (
      <h2
        className="font-merriweather mb-6 text-3xl leading-[48px] lg:text-[40px] lg:leading-[72px] md:text-center text-left"
        dangerouslySetInnerHTML={{ __html: blok.title }}
      />
    )}
    <ul
      className={`grid grid-cols-1 md:grid-cols-3 gap-2 md:gap-6 px-0 mx-0 py-4 items-center md:pt-6`}
    >
      {blok.items?.map((row, idx) => (
        <li key={idx} className="flex items-center text-md md:text-lg">
          <span aria-hidden className="mr-3 text-3xl leading-none">
            {icons?.[idx]}
          </span>

          <span>{row.text}</span>
        </li>
      ))}
    </ul>
  </div>
)

export default HowCSWorks
